import React, { Component } from 'react';
import {
  Container,
  Row,
  Col,
  Button
} from 'reactstrap';

import Map from './comparable_prefectures/Map.js';
import Search from './comparable_prefectures/Search.js';

class ComparablePrefectures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefecture: null,
      province: null,
      index: null
    };
  }

  componentDidMount() {
    const { prefectureId } = this.props;

    if (prefectureId) {
      fetch('/api/prefectures/' + prefectureId).then((resp) => resp.json())
        .then((respJson) => {
          this.setState({ prefecture: respJson.data }, () => {
            fetch(respJson.data.relationships.province.links.related)
              .then((resp) => resp.json())
              .then((provinceResp) => {
                this.setState({ province: provinceResp.data });
              });
          });
        });
      fetch('/api/find_comparable_markets/prefecture_index/' + prefectureId)
        .then((resp) => resp.json())
        .then((respJson) => {
          this.setState({ index: respJson.data.value });
        });
    }
  }

  updateComparablePrefectures(newState) {
    this.setState(newState);
  }

  render() {
    const { tier } = this.props;
    const { prefecture, index, province } = this.state;

    return (
      <Container fluid={true} className="sl-view-shell">
        <div className="sl-view-hero">
          <div>
            <div className="sl-view-kicker">Find Comparable Markets</div>
            <h1 className="sl-view-title">Select Comparable Markets</h1>
            <p className="sl-view-subtitle">Use similarity index and prefecture attributes to shortlist comparable markets.</p>
          </div>
          <span className="sl-view-meta">Step 3 of 4</span>
        </div>

        <Row className="sl-grid-gap">
          <Col md="6">
            <Map
              tier={tier}
              index={index}
              province={province}
              prefecture={prefecture} />
            <Button color="primary" tag="a" href={'/find_comparable_markets/tier/' + tier} className="sl-inline-action" outline>
              Back to Prefectures
            </Button>
          </Col>
          <Col md="6">
            <Search
              tier={tier}
              index={index}
              prefecture={prefecture}
              updateComparablePrefectures={this.updateComparablePrefectures.bind(this)} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ComparablePrefectures;
